import { DrupalJsonApiParams } from 'drupal-jsonapi-params';

// A helper function to build params for a resource type.
export function getParams(
  name: string,
  mode: string = null
): DrupalJsonApiParams {
  const params = new DrupalJsonApiParams();

  if (
    mode ||
    !(
      name.startsWith('node') ||
      name.startsWith('taxonomy_term') ||
      name == 'global_search' ||
      name.startsWith('shopify') ||
      name.startsWith('paragraph')
    )
  ) {
    params.addFilter('status', '1');
  }
  name = mode ? `${name}--${mode}` : name;
  if (name === 'block_content--footer') {
    return params.addFields('block_content--footer', [
      'field_logo',
      'field_top_links',
      'field_bottom_links',
      'field_copyright',
    ]);
  }
  if (name === 'block_content--prefooter') {
    return params
      .addFields('block_content--prefooter', [
        'field_faq_title',
        'field_faq_text',
        'field_faqs',
        'field_help_title',
        'field_help_text',
        'field_help_cta',
        'field_newsletter_title',
        'field_newsletter_text',
        'field_form',
      ])
      .addFields('paragraph--faq', ['field_title', 'field_text'])
      .addInclude(['field_faqs']);
  }
  if (name === 'block_content--header') {
    return params
      .addFields('block_content--header', [
        'field_logo',
        'field_menus',
        'field_icon_items',
      ])
      .addFields('paragraph--header_menu', [
        'field_title',
        'field_inner_title',
        'field_links',
        'field_see_more_link',
        'field_highlighted_links',
      ])
      .addFields('paragraph--highlighted_links', [
        'field_title',
        'field_link_items',
      ])
      .addFields('paragraph--highlighted_link', [
        'field_image',
        'field_link',
        'field_title',
      ])
      .addFields('paragraph--icon_item', ['field_icon', 'field_plain_text'])
      .addFields('media--logo', ['field_media_image'])
      .addFields('media--icon', ['field_media_svg'])
      .addFields('media--miscellaneous_image', ['field_media_image'])
      .addInclude([
        'field_logo.field_media_image',
        'field_menus',
        'field_icon_items',
        'field_icon_items.field_icon.field_media_svg',
        'field_menus.field_highlighted_links',
        'field_menus.field_highlighted_links.field_link_items',
        'field_menus.field_highlighted_links.field_link_items.field_image.field_media_image',
      ]);
  }
  if (name === 'node--legal_page') {
    return params.addFields('node--legal_page', [
      'title',
      'field_text',
      'metatag',
      'status',
      'path',
    ]);
  }
  if (name === 'node--landing_page') {
    return params.addFields('node--landing_page', [
      'title',
      'field_dark_banner',
      'field_content',
      'field_show_prefooter',
      'field_show_header',
      'metatag',
      'status',
      'path',
    ]);
  }
  if (name === 'paragraph--formatted_text_block') {
    return params.addFields('paragraph--formatted_text_block', ['field_text']);
  }
  if (name === 'paragraph--popup') {
    return params
      .addFields('paragraph--popup', [
        'field_cta',
        'field_image',
        'field_plain_text',
        'field_title',
      ])
      .addFields('media--miscellaneous_image', ['field_media_image'])
      .addInclude(['field_image.field_media_image']);
  }
  if (name === 'paragraph--origin_block') {
    return params
      .addFields('paragraph--origin_block', [
        'field_title',
        'field_text',
        'field_zig_zag_items',
      ])
      .addFields('paragraph--zig_zag_item', [
        'field_title',
        'field_text',
        'field_image',
      ])
      .addFields('media--miscellaneous_image', ['field_media_image'])
      .addInclude([
        'field_zig_zag_items',
        'field_zig_zag_items.field_image.field_media_image',
      ]);
  }
  if (name === 'node--article') {
    return params
      .addFields('node--article', [
        'title',
        'field_dark_banner',
        'field_category',
        'field_text',
        'field_image',
        'field_reading_time',
        'field_links',
        'changed',
        'created',
        'metatag',
        'status',
        'path',
      ])
      .addFields('media--miscellaneous_image', ['field_media_image'])
      .addFields('taxonomy_term--article_category', ['name','path'])
      .addInclude(['field_image.field_media_image', 'field_category']);
  }
  if (name === 'node--article--card') {
    return params
      .addFields('node--article', [
        'path',
        'title',
        'field_category',
        'field_image',
        'field_summary',
      ])
      .addFields('taxonomy_term--article_category', ['name'])
      .addInclude(['field_image.field_media_image', 'field_category']);
  }
  if (name === 'taxonomy_term--article_category') {
    return params.addFields('taxonomy_term--article_category', [
      'path',
      'name',
      'field_hide_in_listing',
      'metatag',
      'drupal_internal__tid',
    ]);
  }
  if (name === 'paragraph--traceability_block') {
    return params
      .addFields('paragraph--traceability_block', [
        'field_link',
        'field_properties',
        'field_text',
        'field_title',
      ])
      .addFields('paragraph--property', ['field_title', 'field_plain_text'])
      .addInclude(['field_properties']);
  }
  if (name === 'paragraph--complex_code_block') {
    return params.addFields('paragraph--complex_code_block', [
      'field_pretitle',
      'field_title',
      'field_text',
      'field_link',
      'field_left_text',
      'field_left_title',
    ]);
  }
  if (name === 'paragraph--logo_block') {
    return params
      .addFields('paragraph--logo_block', [
        'field_title',
        'field_text',
        'field_logos',
      ])
      .addFields('media--logo', ['field_media_image'])
      .addInclude(['field_logos.field_media_image']);
  }
  if (name === 'paragraph--banner_slider') {
    return params
      .addFields('paragraph--banner_slider', ['field_slides'])
      .addFields('paragraph--image_slide', [
        'field_title',
        'field_plain_text',
        'field_cta',
        'field_image_4xl',
        'field_image_3xl',
        'field_image_2xl',
        'field_image_xl',
        'field_image_l',
        'field_image_m',
        'field_image_s',
        'field_image_xs',
        'field_default_image',
        'field_dark_banner',
        'field_heading',
      ])
      .addFields('paragraph--video_slide', [
        'field_title',
        'field_plain_text',
        'field_cta',
        'field_video_h264',
        'field_video_h265',
        'field_dark_banner',
        'field_heading',
      ])
      .addFields('media--video', ['field_media_video_file'])
      .addFields('media--miscellaneous_image', ['field_media_image'])
      .addInclude([
        'field_slides',
        'field_slides.field_default_image.field_media_image',
        'field_slides.field_image_4xl.field_media_image',
        'field_slides.field_image_3xl.field_media_image',
        'field_slides.field_image_2xl.field_media_image',
        'field_slides.field_image_l.field_media_image',
        'field_slides.field_image_m.field_media_image',
        'field_slides.field_image_s.field_media_image',
        'field_slides.field_image_xs.field_media_image',
        'field_slides.field_video_h264.field_media_video_file',
        'field_slides.field_video_h265.field_media_video_file',
      ]);
  }
  if (name === 'block_content--social_block') {
    return params
      .addFields('block_content--social_block', ['field_social_links'])
      .addFields('paragraph--social_link', ['field_icon', 'field_link'])
      .addFields('media--icon', ['field_media_svg'])
      .addInclude(['field_social_links.field_icon.field_media_svg']);
  }
  if (name === 'paragraph--icon_block') {
    return params
      .addFields('paragraph--icon_block', [
        'field_title',
        'field_text',
        'field_complex_icon_items',
      ])
      .addFields('paragraph--complex_icon_item', [
        'field_icon',
        'field_title',
        'field_plain_text',
      ])
      .addFields('media--icon', ['field_media_svg'])
      .addInclude(['field_complex_icon_items.field_icon.field_media_svg']);
  }
  if (name === 'paragraph--banner') {
    return params
      .addFields('paragraph--banner', [
        'field_title',
        'field_plain_text',
        'field_icon',
        'field_pretitle',
        'field_image',
        'field_link',
      ])
      .addFields('media--miscellaneous_image', ['field_media_image'])
      .addFields('media--raster_icon', ['field_media_image'])
      .addInclude([
        'field_image.field_media_image , field_icon.field_media_image',
      ]);
  }
  if (name === 'paragraph--live_shopping_block') {
    return params.addFields('paragraph--live_shopping_block', [
      'field_spockee_api_key',
    ]);
  }
  if (name === 'paragraph--icon_slider') {
    return params
      .addFields('paragraph--icon_slider', [
        'field_title',
        'field_pretitle',
        'field_complex_icon_items',
      ])
      .addFields('paragraph--complex_icon_item', [
        'field_icon',
        'field_title',
        'field_plain_text',
      ])
      .addFields('media--icon', ['field_media_svg'])
      .addInclude(['field_complex_icon_items.field_icon.field_media_svg']);
  }
  if (name === 'paragraph--banner') {
    return params
      .addFields('paragraph--banner', [
        'field_title',
        'field_plain_text',
        'field_icon',
        'field_pretitle',
        'field_image',
        'field_link',
      ])
      .addFields('media--miscellaneous_image', ['field_media_image'])
      .addFields('media--raster_icon', ['field_media_image'])
      .addInclude([
        'field_image.field_media_image , field_icon.field_media_image',
      ]);
  }
  if (name === 'paragraph--webform_block') {
    return params
      .addFields('paragraph--webform_block', [
        'field_title',
        'field_text',
        'field_image',
        'field_form',
      ])
      .addFields('media--miscellaneous_image', ['field_media_image'])
      .addInclude(['field_image.field_media_image']);
  }
  if (name === 'paragraph--article_block') {
    return params.addFields('paragraph--article_block', [
      'field_title',
      'field_text',
    ]);
  }
  if (name === 'paragraph--zig_zag_block') {
    return params
      .addFields('paragraph--zig_zag_block', ['field_zig_zag_items'])
      .addFields('paragraph--zig_zag_item', [
        'field_image',
        'field_title',
        'field_text',
      ])
      .addFields('media--miscellaneous_image', ['field_media_image'])
      .addInclude([
        'field_zig_zag_items',
        'field_zig_zag_items.field_image.field_media_image',
      ]);
  }
  if (name === 'shopify_product--shopify_product--card') {
    return params
      .addFields('shopify_product--shopify_product', [
        'sorting_weight',
        'status',
        'title',
        'variants',
        'tags',
        'options',
        'metatag',
        'image',
        'extra_images',
        'metafields',
        'path',
        'product_id',
        'field_alternate_title',
      ])
      .addFields('taxonomy_term--shopify_tags', ['name'])
      .addFields('shopify_product_variant--shopify_product_variant', [
        'compare_at_price',
        'price',
        'variant_id',
        'inventory_quantity',
      ])
      .addSort('sorting_weight', 'ASC')
      .addInclude(['variants', 'image', 'extra_images', 'tags']);
  }
  if (name === 'paragraph--product_list') {
    return params
      .addFields('paragraph--product_list', [
        'field_tag',
        'field_slider',
        'field_columns',
        'field_title',
      ])
      .addFields('taxonomy_term--shopify_tags', ['name'])
      .addInclude(['field_tag']);
  }
  if (name === 'shopify_product--shopify_product') {
    return params
      .addFields('shopify_product--shopify_product', [
        'title',
        'variants',
        'tags',
        'options',
        'metatag',
        'image',
        'extra_images',
        'metafields',
        'product_id',
        'field_about',
        'field_nutritional_information',
        'field_traceability',
        'body_html',
        'field_perks_title',
        'field_perks',
        'field_weight',
        'path',
      ])
      .addFields('taxonomy_term--shopify_tags', ['name'])
      .addFields('shopify_product_variant--shopify_product_variant', [
        'compare_at_price',
        'price',
        'variant_id',
        'inventory_quantity',
      ])
      .addFields('paragraph--table', [
        'field_description_title',
        'field_description',
        'field_table_title',
        'field_rows',
      ])
      .addFields('paragraph--table_row', ['field_attribute', 'field_value'])
      .addFields('paragraph--product_info', [
        'field_image',
        'field_text',
        'field_title',
        'field_right_aligned',
      ])
      .addFields('paragraph--traceability_block', [
        'field_text',
        'field_title',
        'field_properties',
      ])
      .addFields('paragraph--property', ['field_plain_text', 'field_title'])
      .addInclude([
        'field_nutritional_information.field_rows',
        'variants',
        'image',
        'extra_images',
        'tags',
        'field_about.field_image.field_media_image',
        'field_traceability.field_properties',
      ]);
  }
  if (name === 'block_content--product_advantages') {
    return params
      .addFields('block_content--product_advantages', ['field_icon_items'])
      .addFields('paragraph--icon_item', ['field_icon', 'field_plain_text'])
      .addFields('media--icon', ['field_media_svg'])
      .addInclude([
        'field_icon_items',
        'field_icon_items.field_icon.field_media_svg',
      ]);
  }
  if (name === 'node--recipe') {
    return params
      .addFields('node--recipe', [
        'title',
        'field_dark_banner',
        'field_image',
        'field_cooking_time',
        'field_servings',
        'field_difficulty',
        'field_initial_text',
        'field_ingredients',
        'field_extra_ingredients',
        'field_preparation',
        'field_final_text',
        'field_reading_time',
        'field_display_bullets',
        'field_related_recipes',
        'field_category',
        'metatag',
        'changed',
        'created',
        'status',
        'path',
      ])
      .addFields('ingredient_list',[
        'field_title',
        'field_texts'
      ])
      .addFields('taxonomy_term--article_category', [
        'id',
        'name',
        'path',
        'drupal_internal__tid'
      ])
      .addFields('media--miscellaneous_image', ['field_media_image'])
      .addInclude([
        'field_image.field_media_image',
        'field_extra_ingredients',
        'field_category',
        'field_related_recipes.field_image.field_media_image'
      ]);
  }
  if (name === 'node--recipe--card') {
    return params
      .addFields('node--recipe', [
        'path',
        'title',
        'field_image',
        'field_servings',
        'field_difficulty',
        'field_summary',
        'created',
        'field_category'
      ])
      .addFields('taxonomy_term--recipe_category',[
        'id',
        'name'
      ])
      .addInclude(['field_image.field_media_image','field_category']);
  }
  if (name === 'taxonomy_term--recipe_category') {
    return params.addFields('taxonomy_term--recipe_category', [
      'name',
      'id',
      'metatag',
      'drupal_internal__tid'
    ]);
  }

  if (name == 'shopify_product--shopify_product--search') {
    return params
      .addFields('shopify_product--shopify_product', ['path', 'title', 'image'])
      .addInclude(['image']);
  }
  if (name == 'node--article--search') {
    return params
      .addFields('node--article', ['path', 'title', 'field_image'])
      .addInclude(['field_image.field_media_image']);
  }
  if (name == 'node--recipe--search') {
    return params
      .addFields('node--recipe', ['path', 'title', 'field_image'])
      .addInclude(['field_image.field_media_image']);
  }
  if (name === 'block_content--search_suggestions') {
    return params
      .addFields('block_content--search_suggestions', [
        'field_products',
        'field_recipes',
        'field_articles',
      ])
      .addFields('shopify_product--shopify_product', ['path', 'title', 'image'])
      .addFields('node--article', ['path', 'title', 'field_image'])
      .addFields('node--recipe', ['path', 'title', 'field_image'])
      .addInclude([
        'field_products.image',
        'field_recipes.field_image.field_media_image',
        'field_articles.field_image.field_media_image',
      ]);
  }
  if (name === 'taxonomy_term--article_category--llms') {
    return params.addFields('taxonomy_term--article_category', [
      'name',
      'drupal_internal__tid',
      'created',
    ]);
  }
  if (name === 'node--article--llms') {
    return params
      .addFields('node--article', ['path', 'title'])
      .addFields('taxonomy_term--article_category', ['name']);
  }
  if (name === 'shopify_product--shopify_product--llms') {
    return params.addFields('shopify_product--shopify_product', [
      'path',
      'field_alternate_title',
      'field_description',
    ]);
  }
  return params;
}
